import React from "react";

export default function YongggumVillage() {
  const handleBooking = (e) => {
    e.preventDefault();
    alert(
      "현재 웹사이트 연동 정비 중입니다. 예약 및 상세 일정 조율은 문의전화(010-3434-2538)로 유선 연락 부탁드립니다."
    );
  };

  // 🌟 주변 관광지 데이터 배열 (나중에 실제 이미지 주소로 변경 가능)
  const attractions = [
    {
      name: "칠갑산 도립공원",
      image:
        "https://cdn.ardentnews.co.kr/news/photo/202510/8158_38618_5412.jpg",
      desc: "청양의 명산이자 아름다운 자연경관을 품은 웰빙 힐링 코스"
    },
    {
      name: "천장호 출렁다리",
      image:
        "https://www.telltrip.com/wp-content/uploads/2025/06/Cheongyang-Cheonjangho-Swinging-Bridge3.jpg",
      desc: "탁 트인 호수 전경을 감상하며 걷는 청양의 대표 랜드마크"
    },
    {
      name: "칠갑산 장곡사",
      image: "https://cdn.e2news.com/news/photo/201010/44279_10162_1848.jpg",
      desc: "유서 깊은 역사를 간직한 고즈넉하고 평온한 천년고찰"
    }
  ];

  return (
    <div style={styles.fcContainer}>
      {/* 1. 멀티 모자이크 갤러리 */}
      <div style={styles.galleryGrid}>
        <div style={styles.galleryTable}>
          <div style={styles.galleryMainCell}>
            <div
              style={{
                ...styles.imgPlaceholder,
                backgroundImage:
                  'linear-gradient(to bottom, rgba(0,0,0,0.1), rgba(0,0,0,0.4)), url("https://cdn.traveldaily.co.kr/news/photo/201808/16296_22398_3718.jpg")'
              }}
            >
              <div style={styles.imgOverlayText}>대표 전경</div>
            </div>
          </div>
          <div style={styles.gallerySubCell}>
            <div style={styles.subGridTable}>
              <div style={styles.subGridRow}>
                <div style={styles.subGridItem}>
                  <div
                    style={{
                      ...styles.imgPlaceholder,
                      backgroundImage:
                        'url("https://cdn.traveldaily.co.kr/news/photo/201808/16296_22399_3718.jpg")'
                    }}
                  />
                </div>
                <div style={styles.subGridItem}>
                  <div
                    style={{
                      ...styles.imgPlaceholder,
                      backgroundImage:
                        'url("https://cdn.traveldaily.co.kr/news/photo/201808/16296_22400_3718.jpg")'
                    }}
                  />
                </div>
              </div>
              <div style={styles.subGridRow}>
                <div style={styles.subGridItem}>
                  <div
                    style={{
                      ...styles.imgPlaceholder,
                      backgroundImage:
                        'url("https://cdn.traveldaily.co.kr/news/photo/201808/16296_22402_3718.jpg")'
                    }}
                  />
                </div>
                <div style={styles.subGridItem}>
                  <div
                    style={{
                      ...styles.imgPlaceholder,
                      backgroundImage:
                        'url("https://cdn.traveldaily.co.kr/news/photo/201808/16296_22403_3719.jpg")'
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div style={styles.mainLayoutWrapper}>
        <div style={styles.leftContentStream}>
          <div style={styles.farmTitleHeader}>
            <h1
              style={{
                fontSize: "32px",
                fontWeight: "800",
                color: "#1a202c",
                marginBottom: "8px"
              }}
            >
              용꿈 꾸는 마을
            </h1>
            <div
              style={{
                fontSize: "18px",
                color: "#718096",
                marginBottom: "12px"
              }}
            >
              Yongggum Village
            </div>
            <div style={{ fontSize: "14px", color: "#4a5568" }}>
              📍 대한민국 충청남도 청양군 돌보길 72
            </div>
          </div>

          <div style={styles.sectionTitleSub}>농장 한눈에 보기</div>
          <div style={styles.featuresBadgeCloud}>
            {[
              "🚜 농촌 활동 (Activities)",
              "🏡 가족 친화적 (Family-Friendly)",
              "🌾 전통 워크숍 (Workshop)",
              "🪵 캠프파이어 (Bonfire)",
              "🛌 농촌 숙박 (Farmstays)",
              "🎓 교육 프로그램 (Educational)"
            ].map((tag, idx) => (
              <span key={idx} style={styles.fcBadge}>
                {tag}
              </span>
            ))}
          </div>

          <div style={{ marginBottom: "40px" }}>
            <h3
              style={{
                fontSize: "22px",
                fontWeight: "700",
                marginBottom: "16px"
              }}
            >
              여행 정보
            </h3>
            <div
              style={{
                fontSize: "16px",
                color: "#4a5568",
                textAlign: "justify"
              }}
            >
              <p style={{ marginBottom: "16px" }}>
                용꿈꾸는 마을은 청양의 명산인 칠갑산 인근에 위치한 작은 농촌
                마을로, 오염되지 않은 자연 그대로의 아름다운 모습을 고스란히
                간직한 청정 휴양지입니다. 일상에 지친 현대인들을 위해 마을
                주민들이 직접 준비한 재미있고 정겨운 농촌 프로그램을 통해,
                건강한 참살이(웰빙) 체험과 진정한 몸과 마음의 힐링을 경험할 수
                있는 공간입니다.
              </p>
              <p style={{ marginBottom: "16px" }}>
                마을의 자연을 오감으로 느끼는 소나무 화분 만들기, 화전 부치기
                체험부터 계절에 따라 즐기는 옥수수 따기, 고구마 캐기 등 다채로운
                수확의 기쁨이 준비되어 있습니다. 또한 전통 떡메치기와 조상들의
                지혜가 담긴 짚풀 달걀 꾸러미 만들기는 아이들에게 훌륭한 생태
                교육이 됩니다. 특히 용꿈꾸는마을만의 자랑인 '헬기장 체험'은 탁
                트인 전경과 함께 색다른 재미를 선사합니다.
              </p>
              <p style={{ marginBottom: "16px" }}>
                당일 여행객을 위한 맞춤형 산책 및 체험 코스는 물론, 밤하늘의
                쏟아지는 별을 관측하는 천문대 견학과 캠프파이어가 포함된 1박 2일
                여정까지 준비되어 있습니다. 아늑한 '용꿈체험관'에서의 하룻밤은
                시골 고향 집에 온 듯한 따뜻한 인심과 편안한 휴식을 약속합니다.
              </p>
            </div>
          </div>

          <div style={{ borderTop: "1px solid #edf2f7", paddingTop: "32px" }}>
            <div style={styles.sectionTitleSub}>농장 키포인트</div>
            <div style={{ marginBottom: "40px" }}>
              {[
                {
                  title: "🍡 달콤 쫄깃한 전통 떡메치기 놓치지 마세요",
                  body: "전통 방식 그대로 커다란 떡메를 치며 인절미를 직접 만드는 시그니처 프로그램입니다. 갓 만든 떡의 고소함과 쫄깃함을 현장에서 꼭 맛보세요."
                },
                {
                  title: "🚁 마을의 이색 명소, 헬기장에서 인생샷을!",
                  body: "마을 산책로와 연결된 헬기장 공간은 아이들이 가장 좋아하는 이색 체험지입니다. 시원한 청양의 자연 풍경을 배경으로 멋진 기념사진을 남겨보세요."
                },
                {
                  title: "✨ 낭만 가득한 1박 2일 코스와 천문대 투어",
                  body: "1박 2일 코스 선택 시 아늑한 용꿈체험관 숙박과 함께 청정 청양 하늘의 별을 관측하는 칠갑산 천문대 투어, 밤의 낭만을 더할 캠프파이어가 포함되어 완벽한 촌캉스를 완성해 줍니다."
                },
                {
                  title: "🌿 자연 친화적인 복장과 준비물은 필수",
                  body: "수확 체험 및 산책로 걷기 등 야외 활동이 많으므로 편안하고 튼튼한 운동화나 작업용 신발을 착용해 주세요. 햇볕을 가릴 모자와 겉옷을 준비하시면 더욱 좋습니다."
                },
                {
                  title: "📞 모든 체험 코스는 사전 예약제 운영",
                  body: "원활한 프로그램 진행 및 신선한 체험 재료 준비를 위해 방문 전 대표 번호(010-3434-2538)를 통한 사전 예약 및 일정 조율이 필수입니다."
                }
              ].map((reminder, idx) => (
                <div key={idx} style={styles.reminderRowItem}>
                  <span style={styles.reminderCardHeader}>
                    {reminder.title}
                  </span>
                  <span style={styles.reminderCardBody}>{reminder.body}</span>
                </div>
              ))}
            </div>
          </div>

          {/* 🌟 [신규 추가] 주변 관광지 레이아웃 영역 */}
          <div
            style={{
              borderTop: "1px solid #edf2f7",
              paddingTop: "32px",
              marginBottom: "24px"
            }}
          >
            <h3
              style={{
                fontSize: "22px",
                fontWeight: "700",
                marginBottom: "20px"
              }}
            >
              주변 관광지
            </h3>
            <div style={styles.attractionsGrid}>
              {attractions.map((place, idx) => (
                <div key={idx} style={styles.attractionCard}>
                  <div
                    style={{
                      ...styles.attractionImg,
                      backgroundImage: `url("${place.image}")`
                    }}
                  />
                  <div style={styles.attractionInfo}>
                    <h4 style={styles.attractionName}>{place.name}</h4>
                    <p style={styles.attractionDesc}>{place.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div style={styles.rightSidebarStream}>
          <div style={styles.stickyInfoCard}>
            <div style={styles.sidebarWidgetTitle}>농장 기본 정보</div>
            <div style={styles.essentialsRow}>
              <div style={styles.essentialsLabel}>주소 (Address)</div>
              <div style={styles.essentialsValue}>
                대한민국 충청남도 청양군 남양면 돌보길 72
              </div>
            </div>
            <div style={styles.essentialsRow}>
              <div style={styles.essentialsLabel}>문의전화 (Phone)</div>
              <div style={styles.essentialsValue}>
                <a
                  href="tel:010-3434-2538"
                  style={{
                    color: "#1a4331",
                    fontWeight: "600",
                    textDecoration: "underline"
                  }}
                >
                  010-3434-2538
                </a>
              </div>
            </div>

            <div
              style={{
                ...styles.essentialsRow,
                marginTop: "24px",
                borderTop: "1px solid #edf2f7",
                paddingTop: "16px"
              }}
            >
              <div style={styles.essentialsLabel}>Hours (운영 시간)</div>
              <div style={{ ...styles.essentialsValue, fontWeight: "600" }}>
                월요일 ~ 일요일 (상시 운영)
              </div>
              <div
                style={{
                  color: "#1a4331",
                  fontSize: "16px",
                  fontWeight: "600",
                  marginTop: "2px"
                }}
              >
                09:00 AM - 06:00 PM
              </div>
            </div>
            <div style={styles.bookingStatusBox}>
              <div style={{ fontSize: "13px", color: "#4a5568" }}>
                <strong>📢 실시간 예약 연동 안내</strong>
                <br />
                해당 마을은 홈페이지 시스템 정비 완료 후 실시간 예약 연동 슬롯이
                활성화됩니다.
              </div>
            </div>
            <button onClick={handleBooking} style={styles.fcPrimaryBtn}>
              실시간 예약 준비중
            </button>
          </div>

          <div style={{ ...styles.sidebarWidgetTitle, marginTop: "32px" }}>
            위치 및 날씨 정보
          </div>
          <div>
            <div style={styles.mapContainerBox}>
              <iframe
                title="Google Map Yongggum Safe"
                src="https://maps.google.com/maps?q=%EC%Bong%EC%B2%AD%EB%82%A8%EB%8F%84%20%EC%B2%AD%EC%96%91%EA%B5%B0%20%EB%82%A8%EC%96%91%EB%A9%B4%20%EB%8F%8C%EB%B3%B4%EA%B8%B8%2072&t=&z=15&ie=UTF8&iwloc=&output=embed"
                style={styles.mapIframeStyle}
                allowFullScreen=""
                loading="lazy"
              />
            </div>
            <div style={styles.weatherWidgetContainer}>
              <div style={styles.weatherMainRow}>
                <div style={styles.weatherIconAnim}>☀️</div>
                <div>
                  <div style={styles.weatherTempText}>18.5°C</div>
                  <div style={styles.weatherStatusText}>
                    실시간 기상: 맑음 (Clean Air)
                  </div>
                </div>
              </div>
              <div style={styles.weatherDetailGrid}>
                <div style={styles.weatherDetailItem}>
                  <span style={styles.weatherDetailLabel}>습도</span>
                  <span style={styles.weatherDetailValue}>45%</span>
                </div>
                <div style={styles.weatherDetailItem}>
                  <span style={styles.weatherDetailLabel}>풍속</span>
                  <span style={styles.weatherDetailValue}>2.1 m/s</span>
                </div>
                <div style={styles.weatherDetailItem}>
                  <span style={styles.weatherDetailLabel}>미세먼지</span>
                  <span
                    style={{ ...styles.weatherDetailValue, color: "#2FA322" }}
                  >
                    좋음 (15㎛)
                  </span>
                </div>
              </div>
              <div style={styles.weatherUpdateFooter}>
                청양군 기상대 실시간 동네예보 바인딩 완료
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const styles = {
  fcContainer: {
    maxWidth: "1280px",
    margin: "0 auto",
    padding: "24px 40px",
    backgroundColor: "#fcfcf9"
  },
  galleryGrid: {
    display: "block",
    width: "100%",
    marginBottom: "32px",
    borderRadius: "16px",
    overflow: "hidden"
  },
  galleryTable: {
    display: "flex",
    width: "100%",
    minHeight: "60vh",
    gap: "8px"
  },
  galleryMainCell: { flex: 1 },
  gallerySubCell: { flex: 1 },
  subGridTable: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    gap: "8px"
  },
  subGridRow: { display: "flex", flex: 1, gap: "8px" },
  subGridItem: { flex: 1 },
  imgPlaceholder: {
    width: "100%",
    height: "100%",
    backgroundColor: "#e2e8f0",
    backgroundSize: "cover",
    backgroundPosition: "center",
    position: "relative",
    minHeight: "210px",
    borderRadius: "8px"
  },
  imgOverlayText: {
    position: "absolute",
    bottom: "16px",
    left: "16px",
    background: "rgba(0, 0, 0, 0.6)",
    color: "#ffffff",
    padding: "6px 12px",
    fontSize: "12px",
    borderRadius: "4px"
  },
  mainLayoutWrapper: {
    display: "flex",
    width: "100%",
    gap: "48px",
    marginTop: "20px"
  },
  leftContentStream: { flex: 1.8 },
  rightSidebarStream: { flex: 1, minWidth: "320px" },
  farmTitleHeader: {
    marginBottom: "24px",
    borderBottom: "1px solid #2FA322",
    paddingBottom: "24px"
  },
  sectionTitleSub: {
    fontSize: "16px",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    color: "#718096",
    marginBottom: "16px",
    fontWeight: "700"
  },
  featuresBadgeCloud: { display: "block", marginBottom: "36px" },
  fcBadge: {
    display: "inline-block",
    backgroundColor: "#f0fdf4",
    color: "#166534",
    padding: "8px 16px",
    borderRadius: "30px",
    fontSize: "14px",
    fontWeight: "600",
    marginRight: "8px",
    marginBottom: "8px",
    border: "1px solid #bbf7d0"
  },
  reminderRowItem: {
    background: "#ffffff",
    border: "1px solid #e2e8f0",
    borderRadius: "12px",
    padding: "20px",
    marginBottom: "16px",
    display: "flex",
    flexDirection: "column"
  },
  reminderCardHeader: {
    fontSize: "16px",
    fontWeight: "700",
    color: "#1a4331",
    marginBottom: "8px"
  },
  reminderCardBody: { fontSize: "14px", color: "#4a5568" },
  stickyInfoCard: {
    backgroundColor: "#ffffff",
    border: "1px solid #e2e8f0",
    borderRadius: "16px",
    padding: "28px",
    boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.05)"
  },
  sidebarWidgetTitle: {
    fontSize: "18px",
    fontWeight: "700",
    color: "#1a202c",
    marginBottom: "20px",
    borderBottom: "2px solid #1a4331",
    paddingBottom: "8px"
  },
  essentialsRow: { marginBottom: "16px" },
  essentialsLabel: {
    fontSize: "12px",
    fontWeight: "400",
    color: "#a0aec0",
    textTransform: "uppercase",
    marginBottom: "4px"
  },
  essentialsValue: { fontSize: "15px", color: "#2d3748", fontWeight: "500" },
  bookingStatusBox: {
    backgroundColor: "#f7fafc",
    borderRadius: "8px",
    padding: "16px",
    marginTop: "20px",
    borderLeft: "4px solid #cbd5e0"
  },
  fcPrimaryBtn: {
    display: "block",
    width: "100%",
    backgroundColor: "#bebebe",
    color: "#ffffff",
    border: "none",
    padding: "14px",
    borderRadius: "8px",
    fontWeight: "700",
    fontSize: "16px",
    marginTop: "16px",
    cursor: "pointer"
  },
  pluginBox: {
    backgroundColor: "#edf2f7",
    border: "1px dashed #cbd5e0",
    borderRadius: "12px",
    padding: "24px",
    textAlign: "center",
    color: "#718096",
    fontSize: "13px",
    marginBottom: "16px"
  },
  mapContainerBox: {
    width: "100%",
    height: "240px",
    borderRadius: "12px",
    overflow: "hidden",
    marginBottom: "16px",
    border: "1px solid #e2e8f0"
  },
  mapIframeStyle: { border: 0, width: "100%", height: "100%" },

  weatherWidgetContainer: {
    backgroundColor: "#ffffff",
    border: "1px solid #e2e8f0",
    borderRadius: "12px",
    padding: "20px",
    textAlign: "left",
    boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.02)",
    marginBottom: "16px"
  },
  weatherMainRow: {
    display: "flex",
    alignItems: "center",
    gap: "16px",
    marginBottom: "16px",
    borderBottom: "1px solid #f1f3f5",
    paddingBottom: "14px"
  },
  weatherIconAnim: {
    fontSize: "36px",
    lineHeight: "1"
  },
  weatherTempText: {
    fontSize: "24px",
    fontWeight: "800",
    color: "#1a202c",
    lineHeight: "1.2"
  },
  weatherStatusText: {
    fontSize: "13px",
    color: "#718096",
    fontWeight: "500",
    marginTop: "2px"
  },
  weatherDetailGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: "10px",
    textAlign: "center"
  },
  weatherDetailItem: {
    display: "flex",
    flexDirection: "column",
    backgroundColor: "#f8f9fa",
    padding: "8px 4px",
    borderRadius: "6px"
  },
  weatherDetailLabel: {
    fontSize: "11px",
    color: "#a0aec0",
    fontWeight: "600",
    marginBottom: "2px"
  },
  weatherDetailValue: {
    fontSize: "13px",
    color: "#2d3748",
    fontWeight: "700"
  },
  weatherUpdateFooter: {
    fontSize: "10px",
    color: "#cbd5e0",
    textAlign: "right",
    marginTop: "12px",
    fontWeight: "500"
  },

  // 🌟 [신규 추가] 주변 관광지 전용 스타일 규격
  attractionsGrid: {
    display: "flex",
    gap: "16px",
    width: "100%",
    boxSizing: "border-box"
  },
  attractionCard: {
    flex: 1,
    backgroundColor: "#ffffff",
    border: "1px solid #e2e8f0",
    borderRadius: "12px",
    overflow: "hidden",
    boxShadow: "0 2px 4px rgba(0,0,0,0.02)",
    display: "flex",
    flexDirection: "column"
  },
  attractionImg: {
    width: "100%",
    height: "140px",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundColor: "#e2e8f0"
  },
  attractionInfo: {
    padding: "12px"
  },
  attractionName: {
    fontSize: "15px",
    fontWeight: "700",
    color: "#1a202c",
    marginBottom: "4px"
  },
  attractionDesc: {
    fontSize: "12px",
    color: "#718096",
    lineHeight: "1.4",
    margin: 0
  }
};
